import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";

type RouterHistoryBackAction = {
  kind: "router-history";
  navigate: NavigateFunction;
  delta?: number;
};

type TargetRouteBackAction = {
  kind: "target-route";
  navigate: NavigateFunction;
  to: To;
  options?: NavigateOptions;
};

export type ReceptionBackAction = RouterHistoryBackAction | TargetRouteBackAction;

/**
 * 受付画面の戻る操作を共通化して実行します。
 *
 * `kind` が `"router-history"` の場合は履歴を移動し、`delta` 未指定時は `-1` を使って1つ前の画面へ戻ります。
 * `kind` が `"target-route"` の場合は指定したルートへ遷移し、`options` があればあわせて適用します。
 */
export const runReceptionBack = (action: ReceptionBackAction): void => {
  if (action.kind === "router-history") {
    action.navigate(action.delta ?? -1);
    return;
  }

  if (action.options) {
    action.navigate(action.to, action.options);
    return;
  }

  action.navigate(action.to);
};
